import { render, staticRenderFns } from "./GroupPostCreate.vue?vue&type=template&id=33c6fb52&scoped=true&"
import script from "./GroupPostCreate.vue?vue&type=script&lang=js&"
export * from "./GroupPostCreate.vue?vue&type=script&lang=js&"
import style0 from "./GroupPostCreate.vue?vue&type=style&index=0&id=33c6fb52&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c6fb52",
  null
  
)

export default component.exports